/* Panel de sistema — estilos intencionalmenteminimalistas (sin theme) */
export const styles = {
  wrapper: {
    minHeight: '100vh',
    background: '#0a0a0a',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    background: '#141414',
    border: '1px solid #2a2a2a',
    borderRadius: '8px',
    padding: '40px',
    width: '320px',
  },
  title: {
    color: '#888',
    fontSize: '14px',
    textAlign: 'center',
    marginBottom: '24px',
    letterSpacing: '2px',
    textTransform: 'uppercase',
  },
  form:  { display: 'flex', flexDirection: 'column', gap: '12px' },
  input: {
    background: '#1e1e1e',
    border: '1px solid #333',
    borderRadius: '4px',
    padding: '10px 12px',
    color: '#ccc',
    fontSize: '14px',
    outline: 'none',
  },
  btn: {
    background: '#222',
    border: '1px solid #444',
    borderRadius: '4px',
    color: '#aaa',
    padding: '10px',
    cursor: 'pointer',
    fontSize: '14px',
    marginTop: '8px',
  },
  error: { color: '#e74c3c', fontSize: '13px', margin: 0 },
};
